import { Box, Center, Flex } from "@chakra-ui/react";
import { OrderStatus } from "lib/api/enum";
import { getOrderStatusStepString } from "../string/getString";

interface StepComponentProps {
    active: boolean;
    isParcel: boolean;
    stepStatus: OrderStatus;
}

const StepComponent = (props: StepComponentProps) => {
    return (
        <Flex flexDirection={"column"} w="3rem" zIndex={1}>
            <Box
                alignSelf={"center"}
                w="0.875rem"
                h="0.875rem"
                mb="0.375rem"
                bg={"white"}
                borderWidth={"3px"}
                borderColor={props.active ? "mint.500" : "#f5f5f5"}
                borderRadius={"full"}
            />
            <Center
                fontSize="0.75rem"
                fontWeight={"semibold"}
                color={props.active ? "mint.500" : "#cfcfcf"}
            >
                {getOrderStatusStepString(props.isParcel, props.stepStatus)}
            </Center>
        </Flex>
    );
};

export default StepComponent;
